import { Flex, FlexProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

type PageProps = {
  children: ReactNode;
} & FlexProps;

export const Page = ({ children, ...rest }: PageProps) => {
  return (
    <Flex flexDir="column" h="100vh" {...rest}>
      {children}
    </Flex>
  );
};
